export const ROOT = '';
export const NOT_FOUND = 'not-found';
export const CONFIGURATOR_NOT_FOUND = 'configurator-not-found';

export const FEATURES = 'features';
export const LOGIN = 'login';
export const ACCOUNT = 'account';
export const PROFILE = 'profile';
export const PASSWORD = 'password';

export const PRODUCTS = 'products';
export const ENVIRONMENTS = 'environments';
export const RENDERS = 'renders';
export const MATERIALS = 'materials';
export const CONFIGURATORS = 'configurators';
export const METADATA = 'metadata';
export const METADATA_UPLOAD = 'upload';

export const PRODUCT = 'product';
export const ENVIRONMENT = 'environment';
export const RENDER = 'render';
export const SPINNER = 'spinner';

export const STUDIO = 'studio';
export const MATERIALS_MAPPER = 'material-slots';
export const CONFIGURATOR_STREAM = 'metabox-configurator';
export const METABOX_VIEWER = 'metabox-viewer';
